import * as React from 'react';
import classNames from 'classnames';
import s from './AppHeader.scss';
import { withInjectedRootStore, RootStore } from 'providers';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { Experiments } from 'enums';

interface LogoProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const LogoComp: React.FC<LogoProps> = ({ rootStore, experiments }) => {
  const { brand } = rootStore.appStore.appContext;
  const showNonBetaEditorXLogo = experiments.enabled(
    Experiments.EditorXNewLogo,
  );

  return (
    <div className={s.logoWrapper}>
      <div
        className={classNames(s.logoSvg, brand, {
          [s.newLogo]: showNonBetaEditorXLogo,
        })}
      />
    </div>
  );
};

export const Logo = withExperiments(withInjectedRootStore(LogoComp));
